<template>
    <div class="justify-content-end">
        <h2 class=" float-start ">{{ $trans.get('__JSON__.Without external timestamps') }}</h2>
        <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge"
                style="font-size: 0.7rem; transform: translateY(-0.7rem);">
                {{ getCountExternalTimesMissing() }}
            </div>
        <span class="material-symbols-outlined float-end text-primary" style="font-size:25px;" data-toggle="tooltip" title="Bitte in Novatime nachtragen!">
            info
        </span>
    </div>
    <!-- <i class="fa fa-question-circle text-primary ml-auto" ></i> -->
    <table class="table table-striped hover-zoom">
        <thead>
<tr>
            <th role="button" @click.prevent="sortColumn = 'employee'">
                {{ $trans.get('__JSON__.Employee') }}
                <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'location'">
                {{ $trans.get('__JSON__.Location') }}
                <i v-if="sortColumn == 'location'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'team'">
                {{ $trans.get('__JSON__.Team') }}
                <i v-if="sortColumn == 'team'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'day'">
                {{ $trans.get('__JSON__.Day') }}
                <i v-if="sortColumn == 'day'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'start_at'">
                {{ $trans.get('__JSON__.start_at') }}
                <i v-if="sortColumn == 'start_at'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'end_at'">
                {{ $trans.get('__JSON__.end_at') }}
                <i v-if="sortColumn == 'end_at'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.Action') }}
            </th>
            </tr>   
        </thead>
        <tbody>
            <tr v-for="externalTimeMissing in sortedExternalTimesMissing" :key="'et-' + externalTimeMissing.id">
                <td>
                    <employee employeelink="1" :employee="externalTimeMissing.employee" />
                </td>
                <td>
                    {{ externalTimeMissing.employee.location?.name }}
                </td>
                <td>
                    {{ externalTimeMissing.employee.team?.name }}
                </td>
                <td>
                    <i v-if="isYesterdayOrBefore(externalTimeMissing.start_at)" class="fa fa-warning text-danger"
                        v-tooltip title="Warnung älter als ein Tag!"></i>&nbsp;
                    {{ toYMDFormat(externalTimeMissing.day) }}
                </td>
                <td>
                    {{ toYMDHMFormat(externalTimeMissing.start_at) }}
                </td>
                <td>
                    {{ toYMDHMFormat(externalTimeMissing.end_at) }}
                </td>
                <td>
                    <a v-if="can('externaltime-list-all') && isOlderThanFourDays(externalTimeMissing.start_at) == true"
                        class="btn btn-primary" href="" @click.prevent="putExternalOuttime(externalTimeMissing)">
                        {{ $trans.get('__JSON__.Acknowledge') }}</a>
                </td>
            </tr>
        </tbody>
    </table>
</template>



<script>
import axios from "axios";
import getExternalTimesMissing from "../composables/getExternalTimesMissing";
import getEmployees from "../composables/getEmployees";

export default {

    name: "ExternalTimesListMissing",

    props: {
        monitor_others: Boolean,
        view_locations: Object,
    },
    setup(props) {
        const { externalTimesMissing, externalTimeMissing_error, loadExternalTimesMissing, setExternalOuttime } = getExternalTimesMissing();
        loadExternalTimesMissing(props.monitor_others, props.view_locations);
        const { employees, employees_error, loadEmployees } = getEmployees();
        loadEmployees(null, [
            null
        ]);

        return { externalTimesMissing, externalTimeMissing_error, loadExternalTimesMissing, loadEmployees, setExternalOuttime };
    },
    data() {
        return {
            sortColumn: 'created_at',
            counted: null,
            employee: null,
        };
    },
    created() {
        let refreshtime = 600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData, refreshtime)
    },
    computed: {

        sortedExternalTimesMissing() {
            // Div im Blade verstecken, wenn es keine BEMs gibt.
            if (!this.externalTimesMissing) {
                $('#externalTimesMissingContainer').css('display', 'none');
                return null;
            }

            if (this.externalTimesMissing.length == 0) {
                $('#externalTimesMissingContainer').css('display', 'none');
                return null;
            }

            $('#externalTimesMissingContainer').css('display', 'block');
            return this.externalTimesMissing.sort(this.compareExternalTimeMissing);
        }
    },
    methods: {
        formatDate(dateString) { // mm.d.yyyy

            if (dateString == null) {
                return null;
            }
            const date = new Date(dateString);

            return date.toLocaleDateString().slice(0, 10) + ', ' + date.toLocaleTimeString();
        },
        toYMDFormat(dateString) { // yyyy-mm-dd
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd

            return formattedDate

        },
        toYMDHMFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi

            return formattedDate

        },
        compareExternalTimeMissing(a, b) {
            if (this.sortColumn == 'start_at') {

                if (a.start_at == b.start_at) {
                    return 0;
                }

                if (a.start_at < b.start_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'end_at') {

                if (a.end_at == b.end_at) {
                    return 0;
                }

                if (a.end_at < b.end_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'day') {

                if (a.day == b.day) {
                    return 0;
                }

                if (a.day < b.day) {
                    return -1;
                }

            }

            if (this.sortColumn == 'team') {

                if (a.employee.team_id == b.employee.team_id) {
                    return 0;
                }

                if (a.employee.team_id < b.employee.team_id) {
                    return -1;
                }
            }

            if (this.sortColumn == 'location') {

                if (a.employee.location.id == b.employee.location.id) {
                    return 0;
                }

                if (a.employee.location.id < b.employee.location.id) {
                    return -1;
                }

            }


            if (this.sortColumn == 'employee') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }

                if (a.start_at > b.start_at) {
                    return 1;
                }

                if (a.start_at < b.start_at) {
                    return -1;
                }

                return 0;
            }

            return 0;
        },
        getCountExternalTimesMissing() {
            if (!this.sortedExternalTimesMissing) {
                return counted = 0;
            }
            let counted = this.sortedExternalTimesMissing.length;
            return counted;
        },
        isYesterdayOrBefore(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) <= Date.parse(d)) {
                return true;
            }
            return false;
        },
        isOlderThanFourDays(date) {
            var d = new Date();
            d.setDate(d.getDate() - 4);
            if (Date.parse(date) < Date.parse(d)) {
                return true;
            }
            return false;
        },
        async putExternalOuttime(externalTimeMissing) {
            console.log("put externalOuttime: ", externalTimeMissing);
            await this.setExternalOuttime(externalTimeMissing);

            this.externalTimesMissing = this.externalTimesMissing.filter(function (value, index, arr) {
                return value.id != externalTimeMissing.id;
            });
        },
        refreshData() {
            this.loadExternalTimesMissing(this.monitor_others, this.view_locations);
        },

    }
}



</script>
